import { gql } from "@grandvisionhq/graphql";
const CREATE_TICKET = gql`
  mutation CreateTicket($recaptchaToken: String!, $ticketInput: CreateTicketInput!) {
    createTicket(recaptchaToken: $recaptchaToken, ticketInput: $ticketInput) {
      code
      success
      message
    }
  }
`;
export {
  CREATE_TICKET
};
//# sourceMappingURL=create-ticket.js.map
